import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable, Injector, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  _token: any = '';
  private baseUrl: string;

  get token() {
    return this._token;
  }

  set token(val) {
    if (!val) {
      console.log("trying to set an empty token");
      return;
    }
    if (val !== this._token) {
      console.log("token updated");
    }
    this._token = val;
  }

  constructor(private injector: Injector, private router: Router, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url.indexOf('/') === 0 ? req.url.substring(1, req.url.length) : req.url;

    const authReq = req.clone({
      url: url.startsWith('http') ? url : `${this.baseUrl}${url}`,
      headers: req.headers.append('Authorization', "Bearer " + this.token)
        
    });

    return next.handle(authReq).pipe(
      tap(this.handleResponse),
      tap(
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            var response = err;
            console.log(response);
            console.log('req url :: ' + req.url + " " + response.message);

            if (err.status === 401) {
              this.router.navigateByUrl('#!/login');
            }
          }
        }
      ));
  }

  // Handle Cayuse authentication error to avoid endless redirect loop.
  private handleResponse(ev: HttpEvent<any>) {
    if (ev instanceof HttpResponse) {
      const response = ev;

      // If cayuse authentication fails it will return status code 201.
      if (response.status !== 201) {
        return;
      }

      const body = response.body;
      if (body.type !== "redirect") {
        return;
      }

      window.location = body.url;
    }
  }
}
